import { useNavigate } from 'react-router';
import { toast } from 'sonner';

import { usePageTitle } from '@/hooks/use-page-title';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { fleetVehiclePath } from '@/products/fleet/fleet-paths';
import { FleetVehicleForm } from '@/products/fleet/features/fleet-vehicle-form';
import { useCreateFleetVehicle } from '@/products/fleet/features/use-fleet';

export function FleetVehicleNewPage() {
  usePageTitle('Fahrzeug anlegen');
  const navigate = useNavigate();
  const create = useCreateFleetVehicle();

  return (
    <div className="space-y-6">
      <PlatformPageHeader title="Fahrzeug anlegen" />
      <FleetVehicleForm
        pending={create.isPending}
        onCreate={async (body) => {
          const created = await create.mutateAsync(body);
          toast.success('Fahrzeug gespeichert.');
          await navigate(fleetVehiclePath(created.id));
        }}
      />
    </div>
  );
}
